import apiLogin from './apiLogin'


const logout = (body) => {
        return apiLogin.post(`/Usuario/Logout`, body)
};

export default {
    logout
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/logout.js